<!-- 
TODO:
why do we have/need [long-house] vs [house] ? I think for the large screen and small screen sizes
-->

<mat-card-content long-house class="content">
  <div class="top-details">
    <section>
      <mat-card-title>Apartment type ??</mat-card-title>
      <mat-card-subtitle>Posted 3 days ago</mat-card-subtitle>
    </section>
    <section>
      <span>&#8358;57,000</span>
      <span class="mat-caption"> /month</span>
    </section>
  </div>
  <div>
    <section>
      <p>Details: 5.56k / sq.ft</p>
      <p>Status: Unfurnished, Immediately available</p>
    </section>
  </div>
  <div class="post-info-actions">
    <section class="post-amenities">
      <div class="amenity">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
        <span class="mat-caption">4 rooms</span>
      </div>
      <div class="amenity">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
        <span class="mat-caption">4 rooms</span>
      </div>
      <div class="amenity">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
        <span class="mat-caption">4 rooms</span>
      </div>
    </section>

    <section class="post-buttons">
      <button type="button" mat-raised-button [matMenuTriggerFor]="chatMenuBig">
        More
      </button>
      <button type="button" [@iconChangeAnimation]="toggleBookmarkIcon" (click)="bookmarkPost()" mat-icon-button
        color="primary" aria-label="Save this post">
        <mat-icon [fontIcon]="toggleBookmarkIcon"></mat-icon>
      </button>
      <button type="button" [@iconChangeAnimation]="toggleFavouriteIcon" (click)="favouritePost()" mat-icon-button
        color="primary" aria-label="Like this post">
        <mat-icon [fontIcon]="toggleFavouriteIcon"></mat-icon>
      </button>

      <mat-menu #chatMenuBig="matMenu" yPosition="above">
        <!-- @todo: uncomment when we have phone numbers -->
        <!-- <button type="button" mat-menu-item (click)="copyAgentPhoneNumber()">
          <mat-icon>phone</mat-icon>
          <span>Copy phone number</span>
        </button> -->
        <button type="button" mat-menu-item disabled>
          <mat-icon>chat</mat-icon>
          <span>Chat {{ accommodationPosterDisplayName }}</span>
          <ng-container *ngIf="!callerService.isLoggedIn">
            <div class="text-xs text-gray-500">Login to chat</div>
          </ng-container>
        </button>
        <button type="button" mat-menu-item (click)="seeHouseDetails()">
          <mat-icon>info</mat-icon>
          <span>View details</span>
        </button>
      </mat-menu>
    </section>
  </div>
</mat-card-content>

<mat-card-content house class="w-[300px]">
  <div class="top-details">
    <section>
      <mat-card-subtitle>
        <time [dateTime]="accommodation.created_at">{{
          accommodation._age
        }}</time><ng-container *ngIf="accommodationPosterDisplayName">, by
        <a class="underline" [routerLink]="['/p', accommodation.CorpMember?.slug_id ?? accommodation.CorpMember?.created_at]">{{ accommodationPosterDisplayName }}</a>
        </ng-container>
      </mat-card-subtitle>
      <mat-card-subtitle>
        <mat-icon inline class="align-bottom">pin_drop</mat-icon>
        {{ accommodation.CorpMember?._location }}</mat-card-subtitle>
      <mat-card-title>{{ accommodation.accommodation_type }}</mat-card-title>
    </section>
    <section>
      <span>&#8358;{{ accommodation._rent }}</span>
      <span class="text-xs"> {{ rentIntervalAbbreviation }}</span>
    </section>
  </div>
  <div>
    <section>
      <p *ngIf="accommodation._status">
        Status: <span class="capitalize">{{ accommodation._status }}</span>
      </p>
      <p *ngIf="accommodation.Location?.address">
        Address: {{ accommodation.Location?.address }}
      </p>
      <p *ngIf="accommodation.available_rooms?.length">
        Available rooms: {{ accommodation.available_rooms.join(', ') }}
      </p>
      <p *ngIf="accommodation.rent_expire_date">
        Available from:
        <time [dateTime]="accommodation.rent_expire_date">
          {{ accommodation.rent_expire_date | date : 'longDate' }}
        </time>
      </p>
    </section>
  </div>
  <div>
    <!-- <section class="post-amenities">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
        <span>4 rooms</span>
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
        <span>4 rooms</span>
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
        <span>4 rooms</span>
      </section> -->

    <section class="post-buttons">
      <ng-container *ngIf="showDeleteOption">
        <button type="button" (click)="deletePost()" mat-icon-button color="warn" aria-label="Delete this post">
          <mat-icon fontIcon="delete"></mat-icon>
        </button>

        <div class="flex-auto"></div>
      </ng-container>

      <button type="button" [@iconChangeAnimation]="toggleFavouriteIcon" (click)="favouritePost()" mat-icon-button
        color="primary" aria-label="Like this post">
        <mat-icon [fontIcon]="toggleFavouriteIcon"></mat-icon>
      </button>
      <button type="button" [@iconChangeAnimation]="toggleBookmarkIcon" (click)="bookmarkPost()" mat-icon-button
        color="primary" aria-label="Save this post">
        <mat-icon [fontIcon]="toggleBookmarkIcon"></mat-icon>
      </button>
      <button 
      *ngIf="showMoreOption"
      type="button" mat-raised-button [matMenuTriggerFor]="chatMenuSmall">
        More
      </button>
      <mat-menu #chatMenuSmall="matMenu" yPosition="above">
        <!-- @todo: uncomment when we have phone number -->
        <!-- <button type="button" mat-menu-item (click)="copyAgentPhoneNumber()">
          <mat-icon>phone</mat-icon>
          <span>Copy phone number</span>
        </button> -->
        <button type="button" mat-menu-item (click)="chatWithSalePoster()">
          <mat-icon>chat</mat-icon>
          <span>Chat {{accommodationPosterDisplayName}}</span>
          <ng-container *ngIf="!callerService.isLoggedIn">
            <div class="text-xs text-gray-500">Login to chat</div>
          </ng-container>
        </button>
        <button *ngIf="false" type="button" mat-menu-item (click)="seeHouseDetails()">
          <mat-icon>info</mat-icon>
          <span>View details</span>
        </button>
      </mat-menu>
    </section>
  </div>
</mat-card-content>